import React, { useState } from "react";
import PropTypes from "prop-types";
import { SFTabs, SFTab } from "../tabBar";
import SFCard, { SFCardHeader, SFCardBody } from "../card";
import { SFStack } from "../grid";
import getStyled from "../../hooks/getStyled";
import { useLocation } from "react-router-dom";

const { styled } = getStyled();

const StyledCard = styled(SFCard)(({ theme, fillpage }) => ({
  marginTop: theme.spacing(3),
  overflow: "unset",
  display: "flex",
  flexDirection: "column",
  flexGrow: fillpage === "true" ? 1 : 0,
  "& .MuiCardHeader-root": {
    borderBottom: `1px solid ${theme.palette.grey225.main}`,
  },
  "& .MuiTabs-flexContainer": {
    paddingLeft: theme.spacing(2),
  },
  "& .MuiTab-root": {
    paddingRight: 0,
    paddingLeft: 0,
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
  },
}));

const SFStyledCardHeader = styled(SFCardHeader)(({ theme }) => ({
  padding: 0,
  paddingTop: theme.spacing(2.5),
}));

const SFCardBodyStyled = styled(SFCardBody)(({ fillpage }) => ({
  padding: "0px !important",
  flexGrow: fillpage === "true" ? 1 : 0,
}));

export const SFCardTab = ({ title, disabled }) => {
  return <SFTab label={title} disabled={disabled} />;
};

SFCardTab.propTypes = {
  title: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  disabled: PropTypes.bool,
  /**Array of actions visible in card header when the tab is active */
  actions: PropTypes.arrayOf(PropTypes.node),
};

const SFTabbedCard = ({ children, onClickTab }) => {
  const location = useLocation();
  const [activeTabIndex, setActiveTabIndex] = useState(
    location?.state?.activeTabIndex ?? 0
  );

  const onClickTabHandler = async (event, newValue) => {
    if (onClickTab) {
      const res = await onClickTab(newValue);
      if (res) {
        setActiveTabIndex(newValue);
      }
    } else {
      setActiveTabIndex(newValue);
    }
  };

  const actions =
    children.find((el, idx) => idx === activeTabIndex).props.actions ?? [];

  const content = children.find((el, idx) => idx === activeTabIndex).props
    .children;

  const fillPage =
    children.find((el, idx) => idx === activeTabIndex).props.fillPage ?? false;

  return (
    <StyledCard fillpage={fillPage.toString()}>
      <SFStyledCardHeader
        title={
          <SFStack justifyContent="space-between">
            <SFTabs value={activeTabIndex} onChange={onClickTabHandler}>
              {children.map((tab, index) => (
                <SFTab
                  label={tab.props.title}
                  key={index}
                  disabled={tab.props.disabled}
                  hidden={tab.props.hidden}
                />
              ))}
            </SFTabs>
            {actions && <div>{actions}</div>}
          </SFStack>
        }
      />
      <SFCardBodyStyled fillpage={fillPage.toString()}>
        {content}
      </SFCardBodyStyled>
    </StyledCard>
  );
};

SFTabbedCard.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node),
  onClickTab: PropTypes.func,
};

export default SFTabbedCard;
